import { H5, P } from "@/components/ui/typography";
import { ContainerPrimary, ContainerSecondary } from "../ui";
import { SubmitButton } from "@/components/ui/button";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE, ROLE } from "@/utils/constant";
import {
  useBulkInsertSiteID,
  useIntegrationHomepass,
} from "@/api/generate-hpdb";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { convertUppercaseLabelToCapitalize } from "../utils/convertUppercaseLabelToCapitalize";
import { formatDateTime } from "@/utils/helper/formatDate";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { getResponseMessage } from "@/utils/helper/getErrorMessage";
import { useEffect } from "react";

interface CreateHomepassHandlerProps {
  isReadOnly?: boolean;
  onStatusChange: (status: string) => void;
}
export function CreateHomepassHandler({
  isReadOnly,
  onStatusChange,
}: CreateHomepassHandlerProps) {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { roles } = useCurrentUser();
  const canAccess =
    roles?.includes(ROLE.ADMINISTRATOR) ||
    roles?.includes(ROLE.VALIDATOR_DOCUMENT_OFFICER);

  const { data: integrationHomepasss } = useIntegrationHomepass({ rfsId: id });
  const integrationHomepass = integrationHomepasss?.[0];

  useEffect(() => {
    if (integrationHomepass) {
      onStatusChange(integrationHomepass?.status?.toLowerCase());
    }
  }, [integrationHomepass, onStatusChange]);

  const { mutate, isPending } = useBulkInsertSiteID();

  const handleProcess = () => {
    mutate(
      {
        id: id,
      },
      {
        onSuccess: (result) => {
          const originalData = result.data.original;
          if (originalData.status == "error") {
            swalError.fire({
              text: getResponseMessage(result, "Failed upload data Homepass"),
            });
          } else {
            swalSuccess.fire({
              text: "Successfully upload data Homepass",
            });
          }
        },
        onError: (error) => {
          swalError.fire({
            text: getResponseMessage(error),
          });
        },
      },
    );
  };

  return (
    <ContainerPrimary>
      <div className="flex-grow whitespace-nowrap">
        <H5>Create Homepass (SiteID)</H5>
        <P>
          Last Update:{" "}
          {integrationHomepass?.updatedDate
            ? formatDateTime(integrationHomepass?.updatedDate)
            : "-"}
        </P>
      </div>
      <ContainerSecondary>
        <P className="flex-grow text-axiata-blue dark:text-neutral-300">
          {convertUppercaseLabelToCapitalize(integrationHomepass?.status)}
        </P>
        <SubmitButton
          loading={isPending}
          onClick={handleProcess}
          className="ml-auto"
          disabled={isReadOnly || !canAccess || !integrationHomepass}
        >
          Process
        </SubmitButton>
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
